import { Route, Routes } from 'react-router-dom';
import { SideNav } from 'src/common/components/SideNav';

import { AutoScaling } from './auto-scaling';
import { CampaignDetails } from './campaign-detail';
import { Dashboard } from './dashboard';
import LegalEntities from './legal-entities';
import { Phones } from './phone';

const MENU = [
  { title: 'Dashboard', url: '/app/tcr', icon: 'layout-dashboard' },
  { title: 'Phones', url: '/app/tcr/phones', icon: 'phone' },
  { title: 'Legal Entities', url: '/app/tcr/legal_entities', icon: 'home' },
  { title: 'Campaign Details', url: '/app/tcr/campaign_details', icon: 'volume-2' },
  { title: 'Manual Scaling', url: '/app/tcr/scaling', icon: 'git-branch-plus' },
];

export const Tcr: React.FC = () => {
  return (
    <div className="flex h-full">
      <SideNav items={MENU} />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/phones" element={<Phones />} />
          <Route path="/legal_entities/*" element={<LegalEntities />} />
          <Route path="/scaling" element={<AutoScaling />} />
          <Route path="/campaign_details/*" element={<CampaignDetails />} />
        </Routes>
      </div>
    </div>
  );
};
